import { createFileRoute, useRouter } from '@tanstack/react-router'

import styles from './styles.module.scss'
import { cardsServiceInstance } from '@/services/cards.service'
import { useMemo } from 'react'
import { currencyFormat } from '@/utils/currency-format'

export const Route = createFileRoute('/mobile/__base-layout/card/$cardId/')({
  component: RouteComponent,
  async loader({ params: { cardId } }) {
    const card = await cardsServiceInstance.get(cardId)

    return card
  },
  shouldReload: true,
})

function makeForView(numbers: number[]) {
  const viewGrid: number[][] = []
  let idx = 0;
  for (const num of numbers) {
    if (viewGrid[idx] && viewGrid[idx].length >= 5) {
      idx++
      viewGrid[idx] = []
    }
    if (!viewGrid[idx]) viewGrid[idx] = []
    viewGrid[idx].unshift(num)
  }

  return viewGrid
}

function RouteComponent() {
  const router = useRouter()
  const card = Route.useLoaderData()
  const viewGrid = makeForView(card.drawBalls)
  const quantityOcurrences = useMemo(() => {
    let ocurrences = 0

    for (const number of card.cardBalls) {
      if (card.drawBalls.includes(number)) ocurrences++
    }
    return ocurrences
  }, [card])
  return (
    <div className={styles.container}>
      <header>
        <button onClick={() => router.history.back()}>
          <img
            src="/assets/back_button.png"
          />
        </button>
        <h3>Detalhe do sorteio</h3>
      </header>
      <div className={styles.game_score}>
        {
          viewGrid.map((row, i) => (
            <ul key={i}>
              {row.map((idx) => (
                <li>
                  <img
                    src={`/assets/balls/${idx}.svg`}
                  />
                </li>
              ))}
            </ul>
          ))
        }
      </div>
      <div className={styles.game_your_card}>
        <h3>Sua cartela</h3>

        <div>
          <ul>
            {
              card.cardBalls.map((n) => (
                <li key={n}>
                  {
                    card.drawBalls.includes(n) ? (
                      <img
                        src={`/assets/balls/${n}.svg`}
                      />
                    ) : (
                      <b>{n}</b>
                    )
                  }

                </li>
              ))
            }
          </ul>
        </div>
        <div className={styles.container_result_summary}>
          <div>
            <b>Acertos</b>
            <span>{quantityOcurrences}</span>
          </div>
          <div>
            <b>Prêmio</b>
            <span>{currencyFormat(card.priceValue)}</span>
          </div>
        </div>
        <div>
          <span>ID: {card.key}</span>
        </div>
      </div>
    </div>
  )
}
